/** Vietnamese dictionary — must provide exactly the keys of en.ts (enforced by the Dictionary type) */

import type { Dictionary } from './en'
import { storageVi } from './screens/storage'
import { sharingVi } from './screens/sharing'
import { secretsVi } from './screens/secrets'
import { billingVi } from './screens/billing'
import { searchAnalyticsVi } from './screens/search-analytics'
import { wikiCompileVi } from './screens/wiki-compile'
import { healthVi } from './screens/health'
import { askVi } from './screens/ask'
import { sourcesTabsVi } from './screens/sources-tabs'
import { savedQuestionsVi } from './screens/saved-questions'
import { setupVi } from './screens/setup'

export const vi: Dictionary = {
  ...storageVi,
  ...sharingVi,
  ...secretsVi,
  ...billingVi,
  ...searchAnalyticsVi,
  ...wikiCompileVi,
  ...healthVi,
  ...askVi,
  ...sourcesTabsVi,
  ...savedQuestionsVi,
  ...setupVi,
  'app.tagline': 'Quản lý tri thức cho con người và AI agent',

  'common.loading': 'Đang tải…',
  'common.retry': 'Thử lại',
  'common.cancel': 'Hủy',
  'common.close': 'Đóng',

  'login.continueWithGoogle': 'Tiếp tục với Google',
  'login.continueWithGithub': 'Tiếp tục với GitHub',
  'login.terms': 'Khi tiếp tục, bạn đồng ý với điều khoản dịch vụ và chính sách quyền riêng tư của chúng tôi.',

  'theme.label': 'Giao diện',
  'theme.light': 'Sáng',
  'theme.dark': 'Tối',
  'theme.system': 'Theo hệ thống',

  'language.label': 'Ngôn ngữ',
  'language.en': 'English',
  'language.vi': 'Tiếng Việt',

  'nav.projects': 'Dự án',
  'nav.overview': 'Tổng quan',
  'nav.wiki': 'Wiki',
  'nav.sources': 'Nguồn',
  'nav.workspace': 'Không gian làm việc',
  'nav.documents': 'Tài liệu',
  'nav.storage': 'Lưu trữ',
  'nav.sites': 'Trang đã host',
  'nav.secrets': 'Bí mật',
  'nav.searchAnalytics': 'Phân tích tìm kiếm',
  'nav.graph': 'Đồ thị tri thức',
  'nav.settings': 'Cài đặt',
  'nav.billing': 'Thanh toán',
  'nav.profile': 'Hồ sơ',

  'shell.openMenu': 'Mở menu điều hướng',
  'shell.closeMenu': 'Đóng menu điều hướng',
  'shell.newProject': 'Dự án mới',
  'shell.projectsError': 'Không tải được danh sách dự án.',
  'shell.noProjects': 'Chưa có dự án nào.',
  'shell.defaultProject': 'mặc định',

  'topbar.search': 'Tìm kiếm hoặc chạy lệnh',
  'topbar.switchProject': 'Chuyển dự án',
  'topbar.userMenu': 'Menu tài khoản',
  'topbar.signOut': 'Đăng xuất',

  'project.create.title': 'Tạo dự án',
  'project.create.name': 'Tên',
  'project.create.namePlaceholder': 'Ví dụ: Dịch vụ thanh toán',
  'project.create.slug': 'Slug (không bắt buộc)',
  'project.create.slugHint': 'Chữ thường, chữ số và dấu gạch ngang. Để trống sẽ tự tạo từ tên.',
  'project.create.description': 'Mô tả (không bắt buộc)',
  'project.create.repoUrl': 'URL repository (không bắt buộc)',
  'project.create.submit': 'Tạo dự án',
  'project.create.submitting': 'Đang tạo…',
  'project.create.nameRequired': 'Vui lòng nhập tên.',
  'project.create.slugInvalid': 'Slug chỉ gồm chữ thường, chữ số và dấu gạch ngang, không bắt đầu hoặc kết thúc bằng dấu gạch ngang.',
  'project.create.slugTaken': 'Slug "{slug}" đã được dự án khác sử dụng.',
  'project.create.nameTaken': 'Đã có dự án dùng slug tạo từ tên này. Hãy nhập một slug khác.',
  'project.create.failed': 'Không tạo được dự án: {message}',
  'project.create.created': 'Đã tạo dự án "{name}"',

  'project.overview.sources': 'Nguồn',
  'project.overview.pages': 'Trang wiki',
  'project.overview.noDescription': 'Chưa có mô tả.',
  'project.overview.repository': 'Repository',
  'project.overview.defaultProject': 'Dự án mặc định',
  'project.overview.updated': 'Cập nhật {date}',
  'project.overview.notFound': 'Không tìm thấy dự án "{slug}".',
  'project.overview.loadError': 'Không tải được dự án này.',
  'project.overview.backToProjects': 'Đến dự án mặc định',
  'project.overview.open': 'Mở',

  'palette.projects': 'Dự án',
  'palette.workspace': 'Đi tới',
  'palette.preferences': 'Tuỳ chọn',
  'palette.createProject': 'Tạo dự án',
  'palette.setTheme': 'Giao diện: {theme}',
  'palette.setLanguage': 'Ngôn ngữ: {language}',

  'settings.preferences': 'Tuỳ chọn',
  'settings.themeHint': 'Theo hệ thống sẽ dùng cài đặt của hệ điều hành.',
  'settings.languageHint': 'Áp dụng cho khung ứng dụng mới, trang đăng nhập và các tuỳ chọn này.',

  'sources.title': 'Nguồn',
  'sources.subtitle': 'Dữ liệu thô do agent, CLI hoặc trang này đẩy lên. Các trang wiki trích dẫn từ đây.',
  'sources.upload': 'Tải tệp lên',
  'sources.uploading': 'Đang tải lên…',
  'sources.search': 'Tìm theo tiêu đề hoặc tên tệp',
  'sources.status.active': 'Đang dùng',
  'sources.status.superseded': 'Đã thay thế',
  'sources.status.archived': 'Đã lưu trữ',
  'sources.status.all': 'Tất cả',
  'sources.empty': 'Chưa có nguồn nào. Tải tệp lên tại đây hoặc đẩy từ repo của bạn:',
  'sources.col.file': 'Tệp',
  'sources.col.origin': 'Nguồn gốc',
  'sources.col.size': 'Dung lượng',
  'sources.col.added': 'Ngày thêm',
  'sources.uploaded': 'Đã tải lên {count} tệp',
  'sources.unchanged': '{name} không thay đổi',
  'sources.uploadFailed': 'Không tải lên được {name}: {message}',
  'sources.notText': '{name} không phải tệp văn bản',
  'sources.loadError': 'Không tải được danh sách nguồn.',
  'sources.count': '{shown} / {total}',
  'source.back': 'Tất cả nguồn',
  'source.replacedBy': 'Đã được thay bằng phiên bản mới hơn',
  'source.openNewer': 'Mở phiên bản mới hơn',
  'source.archivedNote': 'Đã lưu trữ: vẫn giữ cùng các trích dẫn, nhưng biên dịch, ngữ cảnh và Hỏi đáp không còn đọc nguồn này.',
  'source.archive': 'Lưu trữ',
  'source.restore': 'Khôi phục',
  'source.archived': 'Đã lưu trữ nguồn',
  'source.restored': 'Đã khôi phục nguồn',
  'source.archiveFailed': 'Không đổi được trạng thái nguồn: {message}',
  'source.notFound': 'Không tìm thấy nguồn.',
  'wiki.title': 'Wiki',
  'wiki.subtitle': 'Các trang biên soạn từ Nguồn. Mỗi câu đều dẫn về nơi nó được lấy ra.',
  'wiki.empty': 'Chưa có trang nào được biên soạn. Hãy nhờ coding agent của bạn biên soạn từ Nguồn:',
  'wiki.untopiced': 'Khác',
  'wiki.cited': '{percent}% có trích dẫn',
  'wiki.version': 'v{version}',
  'wiki.loadError': 'Không tải được các trang wiki.',
  'wiki.contents': 'Mục lục',
  'wiki.citedSources': 'Nguồn được trích dẫn',
  'wiki.changes': 'Lịch sử thay đổi',
  'wiki.back': 'Tất cả trang',
  'wiki.notFound': 'Không tìm thấy trang.',
  'context.title': 'Xem trước ngữ cảnh',
  'context.hint': 'Những gì agent nhận được từ `agentwiki context` cho một việc.',
  'context.task': 'Việc cần làm',
  'context.taskPlaceholder': 'ví dụ: thêm migration D1 cho bảng mới',
  'context.budget': 'Ngân sách token',
  'context.includeSources': 'Gồm cả nguồn thô',
  'context.run': 'Tạo ngữ cảnh',
  'context.running': 'Đang tạo…',
  'context.result': '{items} mục, khoảng {used} / {budget} token',
  'context.failed': 'Không tạo được ngữ cảnh: {message}',

  'nav.review': 'Chờ duyệt',
  'review.title': 'Chờ vào Wiki',
  'review.subtitle': 'Các thay đổi agent đề xuất cho wiki. Thêm để đưa vào wiki, hoặc bỏ qua.',
  'review.pending': '{count} đang chờ',
  'review.empty': 'Không có gì chờ duyệt.',
  'review.loadError': 'Không tải được danh sách đề xuất.',
  'review.status.pending': 'Đang chờ',
  'review.status.applied': 'Đã thêm',
  'review.status.discarded': 'Đã bỏ',
  'review.status.all': 'Tất cả',
  'review.newPage': 'Trang mới',
  'review.basedOn': 'Dựa trên v{version}',
  'review.by.agent': 'Agent',
  'review.by.user': 'Người dùng',
  'review.back': 'Danh sách chờ duyệt',
  'review.notFound': 'Không tìm thấy đề xuất.',
  'review.checks': 'Kiểm tra',
  'review.check.citations': '{cited} / {total} câu có trích dẫn nguồn ({percent}%)',
  'review.check.superseded': 'Trích dẫn nguồn đã bị thay thế: {ids}',
  'review.check.stale': 'Trang đã lên v{current} sau khi đề xuất này dựa trên v{base}. Hãy nhờ agent làm lại trên bản mới nhất.',
  'review.check.pinned': 'Thay đổi phần đã ghim: {anchors}',
  'review.check.contradiction': 'Có thể mâu thuẫn ({reason})',
  'review.reason.number': 'số liệu khác nhau',
  'review.reason.negation': 'phủ định bị đảo',
  'review.check.ok': 'Không có vấn đề chặn.',
  'review.diff': 'Thay đổi',
  'review.noDiff': 'Không có dòng nào thay đổi.',
  'review.note': 'Ghi chú (không bắt buộc)',
  'review.add': 'Thêm vào wiki',
  'review.discard': 'Bỏ qua',
  'review.working': 'Đang lưu…',
  'review.added': 'Đã thêm thay đổi vào wiki',
  'review.discarded': 'Đã bỏ đề xuất',
  'review.failed': 'Không lưu được quyết định: {message}',
  'review.decided': '{status} bởi {by}',
  'wiki.pin': 'Ghim phần này',
  'wiki.unpin': 'Bỏ ghim',
  'wiki.pinned': 'Đã ghim: agent không được sửa phần này',
  'wiki.pinFailed': 'Không cập nhật được ghim: {message}',
  'settings.save': 'Lưu',
  'settings.saving': 'Đang lưu…',
  'settings.saved': 'Đã lưu',
  'settings.edit': 'Sửa',
  'settings.remove': 'Gỡ',
  'settings.dismiss': 'Đóng',
  'settings.loadError': 'Không tải được mục này.',
  'settings.saveFailed': 'Không lưu được: {message}',
  'settings.apiKeys.title': 'API key',
  'settings.apiKeys.subtitle': 'Key cho CLI, MCP và script. Mỗi key chỉ có các quyền bạn chọn.',
  'settings.apiKeys.create': 'Tạo API key',
  'settings.apiKeys.newKey': 'API key mới',
  'settings.apiKeys.name': 'Tên',
  'settings.apiKeys.namePlaceholder': 'ví dụ: CLI trên laptop',
  'settings.apiKeys.scopes': 'Quyền',
  'settings.apiKeys.selectAll': 'Chọn tất cả',
  'settings.apiKeys.deselectAll': 'Bỏ chọn tất cả',
  'settings.apiKeys.agentFlags': 'Quyền agent đọc secret (MCP)',
  'settings.apiKeys.agentFlagsHint': 'Cho phép agent kéo giá trị secret thô vào context. Chỉ cấp cho key thật sự cần; mỗi lần reveal vẫn phải được bạn duyệt trên web.',
  'settings.apiKeys.expiresIn': 'Hết hạn sau (ngày, không bắt buộc)',
  'settings.apiKeys.newExpiry': 'Hạn mới tính theo ngày (để trống để giữ hạn hiện tại)',
  'settings.apiKeys.removeExpiry': 'Bỏ hạn (không bao giờ hết hạn)',
  'settings.apiKeys.createSubmit': 'Tạo key',
  'settings.apiKeys.creating': 'Đang tạo…',
  'settings.apiKeys.createFailed': 'Không tạo được key: {message}',
  'settings.apiKeys.updateFailed': 'Không cập nhật được key: {message}',
  'settings.apiKeys.saveNow': 'Sao chép key này ngay. Key sẽ không hiện lại.',
  'settings.apiKeys.copy': 'Sao chép key',
  'settings.apiKeys.empty': 'Chưa có API key nào.',
  'settings.apiKeys.editKey': 'Sửa key',
  'settings.apiKeys.editNamed': 'Sửa {name}',
  'settings.apiKeys.revoke': 'Thu hồi',
  'settings.apiKeys.revokeConfirm': 'Thu hồi key "{name}"? Công cụ đang dùng key này sẽ ngừng hoạt động ngay.',
  'settings.apiKeys.created': 'Tạo {date}',
  'settings.apiKeys.lastUsed': 'Dùng lần cuối {date}',
  'settings.apiKeys.expires': 'Hết hạn {date}',
  'settings.members.title': 'Thành viên',
  'settings.members.subtitle': 'Những người trong workspace này và vai trò của họ.',
  'settings.members.invite': 'Mời thành viên',
  'settings.members.inviteHint': 'Người được mời phải đăng nhập AgentWiki ít nhất một lần trước khi bạn thêm họ.',
  'settings.members.email': 'Email',
  'settings.members.roleLabel': 'Vai trò',
  'settings.members.sendInvite': 'Thêm thành viên',
  'settings.members.inviting': 'Đang thêm…',
  'settings.members.invited': 'Đã thêm thành viên',
  'settings.members.empty': 'Chưa có thành viên nào.',
  'settings.members.roleConfirm': 'Đổi vai trò của {name} thành {role}?',
  'settings.members.removeConfirm': 'Xóa {name} khỏi workspace này?',
  'settings.members.roleFor': 'Vai trò của {name}',
  'settings.members.removeNamed': 'Xóa {name}',
  'settings.members.role.admin': 'Quản trị',
  'settings.members.role.editor': 'Biên tập',
  'settings.members.role.viewer': 'Chỉ xem',
  'settings.members.role.agent': 'Agent',
  'settings.ai.title': 'Nhà cung cấp AI',
  'settings.ai.subtitle': 'Key cho các tính năng AI phía server như tóm tắt và trích xuất graph. Kéo để đặt thứ tự dự phòng. Key được mã hoá khi lưu.',
  'settings.ai.configured': 'Đã cấu hình ({count})',
  'settings.ai.available': 'Có thể thêm ({count})',
  'settings.ai.configure': 'Cấu hình',
  'settings.ai.apiKey': 'API key',
  'settings.ai.enterKey': 'Dán API key của nhà cung cấp',
  'settings.ai.keySaved': 'Đã lưu. Để trống để giữ nguyên.',
  'settings.ai.model': 'Model',
  'settings.ai.enabled': 'Bật',
  'settings.ai.active': 'Đang bật',
  'settings.ai.disabled': 'Đã tắt',
  'settings.ai.dragToReorder': 'Kéo để đổi thứ tự {name}',
  'settings.ai.expand': 'Sửa {name}',
  'settings.ai.collapse': 'Đóng {name}',
  'settings.ai.removeConfirm': 'Gỡ {name}?',
  'settings.ai.usage': 'Mức sử dụng',
  'settings.ai.noUsage': 'Chưa có lượt dùng AI nào.',
  'settings.ai.col.provider': 'Nhà cung cấp',
  'settings.ai.col.model': 'Model',
  'settings.ai.col.action': 'Thao tác',
  'settings.ai.col.tokens': 'Token',
  'settings.ai.col.date': 'Ngày',
  'settings.storage.title': 'Lưu trữ',
  'settings.storage.summary': '{count} tệp · {size}',
  'settings.storage.upload': 'Tải tệp lên',
  'settings.storage.uploading': 'Đang tải lên…',
  'settings.storage.connected': 'Đã kết nối',
  'settings.storage.bucket': 'Bucket',
  'settings.storage.maxFileSize': 'Kích thước tối đa',
  'settings.storage.totalFiles': 'Số tệp',
  'settings.storage.totalSize': 'Tổng dung lượng',
  'settings.storage.r2Hint': 'Bucket mặc định được quản lý trong Cloudflare dashboard. Ảnh chèn vào document được tải lên đây.',
  'settings.storage.empty': 'Chưa có tệp nào.',
  'settings.storage.uploadFirst': 'Tải tệp đầu tiên lên',
  'settings.storage.previewNamed': 'Xem trước {name}',
  'settings.storage.downloadNamed': 'Tải xuống {name}',
  'settings.storage.deleteNamed': 'Xóa {name}',
  'settings.storage.deleteConfirm': 'Xóa "{name}"?',
  'settings.storage.config.title': 'Lưu trữ R2 / S3 riêng',
  'settings.storage.config.verified': 'Đã xác minh',
  'settings.storage.config.notVerified': 'Chưa xác minh',
  'settings.storage.config.default': 'Mặc định',
  'settings.storage.config.hide': 'Ẩn',
  'settings.storage.config.accountId': 'Account ID',
  'settings.storage.config.bucketName': 'Tên bucket',
  'settings.storage.config.endpointUrl': 'Endpoint URL (không bắt buộc, cho storage tương thích S3 khác R2)',
  'settings.storage.config.accessKey': 'Access key ID',
  'settings.storage.config.secretKey': 'Secret access key',
  'settings.storage.config.test': 'Kiểm tra kết nối',
  'settings.storage.config.testOk': 'Kết nối hoạt động.',
  'settings.storage.config.testFailed': 'Kết nối thất bại.',
  'settings.storage.config.removeConfirm': 'Gỡ cấu hình storage riêng và quay về bucket mặc định?',
  'nav.project': 'Dự án',
  'nav.allProjects': 'Tất cả dự án',
  'nav.docs': 'Tài liệu',
  'nav.apiDocs': 'Tài liệu API',
  'nav.cliDocs': 'Tài liệu CLI',
  'nav.opensInNewTab': 'mở trong tab mới',
  'shell.navigation': 'Điều hướng chính',
  'shell.breadcrumb': 'Đường dẫn',
  'shell.currentProject': 'Dự án hiện tại',
  'documents.title': 'Tài liệu',
  'documents.subtitle': 'Các trang bạn và team viết tay. Agent đọc chúng qua tìm kiếm và context.',
  'documents.new': 'Tài liệu mới',
  'documents.search': 'Tìm theo tiêu đề',
  'documents.projectFilter': 'Lọc theo dự án',
  'documents.allProjects': 'Tất cả dự án',
  'documents.loadError': 'Không tải được danh sách tài liệu.',
  'documents.empty': 'Chưa có tài liệu nào.',
  'documents.noMatch': 'Không có tài liệu nào khớp.',
  'documents.pagination': 'Trang',
  'documents.range': '{from}–{to} trên {total}',
  'documents.previous': 'Trước',
  'documents.next': 'Sau',
  'documents.accessLevel': 'Ai được xem',
  'documents.access.private': 'Chỉ mình tôi',
  'documents.access.specific': 'Người được chọn',
  'documents.access.public': 'Công khai (đã publish)',
  'documents.create.title': 'Tài liệu mới',
  'documents.create.docTitle': 'Tiêu đề',
  'documents.create.description': 'Mô tả',
  'documents.create.descriptionHint': 'Một hai câu. Tìm kiếm và agent dùng mô tả để biết khi nào trang này liên quan.',
  'documents.create.required': 'Cần nhập tiêu đề và mô tả.',
  'documents.create.submit': 'Tạo tài liệu',
  'documents.create.submitting': 'Đang tạo…',
  'documents.create.failed': 'Không tạo được tài liệu: {message}',
  'document.back': 'Tất cả tài liệu',
  'document.notFound': 'Tài liệu không tồn tại hoặc bạn không có quyền xem.',
  'document.loadError': 'Không tải được tài liệu này.',
  'document.edit': 'Sửa',
  'document.convert': 'Chuyển sang markdown',
  'document.properties': 'Thuộc tính',
  'document.updated': 'Cập nhật {date}',
  'document.author': 'bởi {name}',
  'document.empty': 'Trang này đang trống.',
  'document.lossy.notice': 'Trang này được viết bằng editor cũ và có định dạng markdown không giữ được ({features}). Ở đây trang chỉ đọc để không mất gì. Chuyển sang markdown để sửa được.',
  'document.lossy.color': 'màu chữ hoặc màu nền',
  'document.lossy.underline': 'gạch chân',
  'document.lossy.alignment': 'căn giữa hoặc căn phải',
  'document.lossy.indentation': 'khối thụt lề',
  'document.lossy.media': 'khối video, audio hoặc tệp',
  'document.lossy.imageSize': 'ảnh đã đổi kích thước',
  'document.lossy.tableLayout': 'độ rộng cột của bảng',
  'document.lossy.unknownBlock': 'khối markdown không biểu diễn được',
  'document.convertTitle': 'Chuyển trang này sang markdown?',
  'document.convertBody': 'Khi bạn lưu, trang chỉ còn bản markdown và các định dạng sau sẽ mất: {features}. Chữ, tiêu đề, danh sách, link, code, trích dẫn, bảng và ảnh vẫn giữ nguyên.',
  'document.convertSnapshot': 'Trước khi lưu, một bản chụp chỉ đọc của phiên bản hiện tại được giữ trong lịch sử phiên bản. Chưa có gì thay đổi cho tới khi bạn bấm Lưu.',
  'document.convertConfirm': 'Tiếp tục sửa',
  'document.titleLabel': 'Tiêu đề',
  'document.titleRequired': 'Cần nhập tiêu đề.',
  'document.contentLabel': 'Nội dung (markdown)',
  'document.editorMode': 'Chế độ soạn',
  'document.write': 'Viết',
  'document.preview': 'Xem trước',
  'document.markdownHint': 'Markdown. Ctrl/⌘ + S để lưu.',
  'document.saveFailed': 'Không lưu được: {message}',
  'document.discardConfirm': 'Bỏ các thay đổi chưa lưu?',
  'projects.title': 'Dự án',
  'projects.subtitle': 'Mỗi dự án có Sources, wiki đã compile và hàng chờ duyệt riêng. Thường mỗi repo một dự án.',
  'projects.edit': 'Sửa dự án',
  'projects.editNamed': 'Sửa {name}',
  'projects.editTitle': 'Sửa dự án',
  'projects.saved': 'Đã lưu dự án "{name}"',
  'projects.slugFixed': 'Slug "{slug}" giữ nguyên để link từ CLI và MCP vẫn hoạt động.',
  'projects.sources': '{count} source',
  'projects.pages': '{count} trang wiki',
  'onboarding.welcome': 'Chào mừng đến với AgentWiki',
  'onboarding.welcomeNamed': 'Chào {name}',
  'onboarding.intro': 'Bắt đầu với một dự án: nơi agent đẩy source lên và AgentWiki giữ wiki đã compile. Mỗi repo một dự án là hợp lý.',
  'onboarding.choose': 'Bạn muốn bắt đầu thế nào?',
  'onboarding.useExisting': 'Dùng dự án đang có',
  'onboarding.useExistingHint': 'Workspace đã có sẵn một dự án. Đặt cho nó cái tên phù hợp.',
  'onboarding.createNew': 'Tạo dự án mới',
  'onboarding.createNewHint': 'Bắt đầu mới, ví dụ cho một repo.',
  'onboarding.projectName': 'Tên dự án',
  'onboarding.descriptionPlaceholder': 'Dự án này nói về gì',
  'onboarding.laterHint': 'Bạn có thể đổi tên và thêm dự án sau.',
  'onboarding.continue': 'Tiếp tục',
  'onboarding.skip': 'Để sau',
  'onboarding.working': 'Đang lưu…',
  'onboarding.failed': 'Có lỗi xảy ra: {message}',
  'settings.tab.profile': 'Hồ sơ',
  'settings.tab.workspace': 'Workspace',
  'settings.tab.graphAi': 'Graph AI',
  'settings.tab.import': 'Nhập dữ liệu',
  'settings.profile.subtitle': 'Cách bạn hiển thị với team.',
  'settings.profile.displayName': 'Tên hiển thị',
  'settings.profile.signOutHint': 'Đăng xuất AgentWiki trên thiết bị này.',
  'settings.workspace.credits': 'Số credit',
  'settings.workspace.creditCount': '{count} credit',
  'settings.workspace.manageBilling': 'Quản lý thanh toán',
  'document.delete': 'Xóa',
  'document.deleteConfirm': 'Xóa "{title}"?',
  'document.deleted': 'Đã xóa "{title}"',
  'document.deleteFailed': 'Không xóa được: {message}',
  'document.descriptionRequired': 'Mô tả không được để trống.',
  'document.convertFailed': 'Không tải được trang này từ định dạng editor cũ. Chưa có gì bị thay đổi.',
  'document.renamePublishedKeepsLink': 'Trang này đã được xuất bản. Liên kết công khai vẫn giữ địa chỉ hiện tại sau khi đổi tên.',
  'document.conflictTitle': 'Trang này đã thay đổi trong lúc bạn chỉnh sửa',
  'document.conflictBody': 'Người khác (hoặc một agent) đã lưu phiên bản mới hơn. Thay đổi của bạn chưa được lưu và vẫn còn trong trình soạn thảo; hãy sao chép phần bạn muốn giữ.',
  'document.conflictLoadLatest': 'Bỏ thay đổi của tôi và tải phiên bản mới nhất',
  'document.conflictDiscardConfirm': 'Bỏ các thay đổi chưa lưu và tải phiên bản mới nhất?',
  'document.conflictCopyDraft': 'Chép bản nháp của tôi',
  'document.conflictDraftCopied': 'Bản nháp đã được chép vào bộ nhớ tạm.',
  'document.conflictCopyFailed': 'Không chép được. Hãy chọn nội dung trong trình soạn thảo rồi chép.',
}
